module.exports = __webpack_public_path__ + "img/cooperate6.19d4fe6a.png";